












































import { Lead } from "@/services/lead.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

import { tipoLead } from "../filters/filters";

@Component({
  filters: {
    tipoLead,
  },
})
export default class LeadCard extends mixins(GlobalMixin) {
  @Prop() readonly value!: Lead | null;
  @Prop() readonly lista!: string | null;

  get dias(): number {
    if (!this.value) {
      return 0;
    }

    return this.formatDiasAtendimento(this.value.dataQualificacao);
  }

  get dataCalendario(): Date | null {
    if (!this.value) {
      return null;
    }

    if (this.value.idStatusLead == 2) {
      return this.value.dataAgendamento || this.value.dataQualificacao;
    }

    return this.value.dataUltimaEtapa;
  }

  branco = false;
  verde = false;
  laranja = false;
  vermelho = false;

  formatMes(data: Date) {
    return dayjs(data).locale("pt-br").format("MMM").toUpperCase();
  }

  formatDia(data: Date) {
    return dayjs(data).format("DD");
  }

  formatDiasAtendimento(data: Date) {
    const diasAtendimento = dayjs().diff(dayjs(data), "day");
    if (diasAtendimento < 2) {
      this.verde = true;
    } else if (diasAtendimento < 3) {
      this.branco = true;
    } else if (diasAtendimento < 5) {
      this.laranja = true;
    } else {
      this.vermelho = true;
    }
    return diasAtendimento;
  }

  formataHora(data: Date) {
    return dayjs(data).format("HH:mm");
  }
}
